(function() {
  
  'use strict';
  
  angular
  .module('ATMGCart')
  .service('Checkout', Checkout);
  
  Checkout.$inject = ['Api.Shipping', 'AddressBook', '$q', '$location', '$rootScope', 'FilterService', 'ErrorService'];
  
  /**
  *   Checkout service def
  *
  */
  function Checkout(Shipping, AddressBook, $q, $location, $rootScope, Filters, Errors) {
    
    // Shipping
    this.Shipping = Shipping;
    
    // link $q to instance
    this.$q = $q;
    
    // link $location to instance
    this.$location = $location;
    
    // link Errors to instance
    this.Errors = Errors;

    // Initialized via .init method
    this.Cart = undefined;

    this._$rootScope = $rootScope
    
    // link address created
    $rootScope.$on('addressBook.addressAdded', function addressAddedEventListener(event, response) {
      var contact_id = response.contact.cust_account_role_id;
      this.setAddress(response.address)
      .then(function() {
        return this.setContactId(contact_id)
      }.bind(this))
    }.bind(this))
    
    // link contact created
    $rootScope.$on('addressBook.contactAdded', function contactAddedEventListener(event, contact) {
      return this.setContactId(contact.cust_account_role_id)
    }.bind(this))
    
    ////////////// AddressBook Methods
    
    /**
    *
    */
    this.getAddressbook = function() {
      return AddressBook.fetchShippingAddresses(Filters.get("addresses"));
    }
    
    /**
    *   setaddress
    */
    this.setAddress = function(address) {
      if (!address) { throw 'Unable to set empty address'; }
      this.address = address;
      // clear contact to bubble up the change
      this.contact.contactId = undefined;
      this.shipping = {}
      return AddressBook.getShippingContacts(address.related_account_number);
    }
    
    /**
    *   fetchShippingAddress
    */
    this.fetchShippingAddress = function(ship_to_id, cart_id) {
      if (!ship_to_id) { throw 'Unable to fetch empty address'; }
      
      var filters = {
        take: 5,
        page: 1,
        cart_id: cart_id
      }
      
      return AddressBook.fetchSingleShippingAddress(filters, ship_to_id)
      .then(function(address) {
        this.setAddress(address);
      }.bind(this))
    }
    
    /**
    *   fetchAndStoreContact
    */
    this.fetchAndStoreContact = function(contact_id) {
      if (!contact_id) { throw 'Unable to set empty contact'; }
      
      var filters = {
        where: {
          cust_account_role_id: contact_id
        }
      }
      
      AddressBook.fetchSingleContact(this.address.related_account_number, filters)
        .then(contact => this.setContactId(contact.cust_account_role_id))
        .catch(reason => {}) // we error before this but just in case
    }
    
    /**
    *   areContactsLoaded
    */
    this.areContactsLoaded = function() {
      return AddressBook.shippingContacts !== undefined;
    }
    
    /**
    *   areContactsLoaded
    */
    this.getContactDetails = function() {
      return AddressBook.contactDetails;
    }
  }
  
  ////////////////// RESET
  
  Checkout.prototype.reset = function() {
    
    // status manager
    this.status = {
      paymentAvailable: false,
      quoteRequested: false,
      unitOnly: false,
      quoteMessage: "Your freight quote has been requested."
    }
    
    // full address instance
    this.address = {};
    
    // contactId
    this.contact = {};
    
    // selected freight option
    // this.freight = undefinedefined
    this.freight = undefined
    // {
      // freight_terms_label: null,
      // freight_terms_code: null,
      // shipment_priority_code: null,
      // shipping_method_code: null
    // };
    
    // selected shipping option
    this.shipping = {
      // service_cost: null,
      // shipping_method_label: null,
      // shipping_method_code: null,
      // shipment_priority_code: null,
      // description: null,
    }
    
    // shipping instructions
    this.instructions = {
      // customer_po_number: null,
      // shipping_instructions: null,
      // packing_instructions: null
    }
    
    // payment informations
    this.payment = {
      payment_terms: "Prepay",
      // card_type: undefined,
      // card_name: null,
      // card_number: null,
      // exp_month: null,
      // exp_year: null
    }
    
    
  }
  
  ////////////////// INIT
  
  /**
  *
  *
  */
  Checkout.prototype.init = function checkoutInit(Cart) {
    if (! Cart) { throw "Checkout init requires a Cart instance"; }
  
    this.Errors.set("This is a shipping error", 'shipping')
    
    this.getAddressbook();
    
    var defer = this.$q.defer();
    var self = this;
    
    // reset Checkout
    this.reset()
    
    // Cart instance
    this.Cart = Cart;
    
    // link listener to Cart.cartUpdated
    // fired after cart has been manipulated so that checkout code knows cart changed
    Cart.cartUpdated = function(promise) {
      return self.cartUpdated(promise);
    }
    
    // load cart sections depending on what's set
    if (Cart.ship_to_id) {
      this.fetchShippingAddress(Cart.ship_to_id, Cart.cart_id)
      .then(function() {
        if (Cart.contact_id) {
          self.fetchAndStoreContact(Cart.contact_id);
        }
      })
      .then(function() {
        defer.resolve(self);
      })
    } else {
      defer.resolve(self);
    }
    
    // link cart's instructions if available
    this.instructions = {
      customer_po_number: Cart.customer_po_number,
      shipping_instructions: Cart.shipping_instructions,
      packing_instructions: Cart.packing_instructions
    }
    
    return defer.promise;
  }
  
  ////////////////// CART UPDATED CALLBACK
  
  /**
  *   cartUpdated
  *   gets a promise from current cart, resolved when update is done
  */
  Checkout.prototype.cartUpdated = function (promise) {
    
    this.Shipping.freightOptions = {};
    this.Shipping.shippingOptions = {};
    // this.freight = undefined
    this.freight = undefined
    this.shipping = {};
    this.status.paymentAvailable = false;
    
    promise.then(function(response) {
      this.Errors.reset('charging')
      if (this.issetContact()) {
        this.getFreightOptions();
      }
    }.bind(this))
  }
  
  ////////////////////// STATUS CHECKING
  
  /**
  *   isUnitOnly
  */
  Checkout.prototype.isUnitOnly = function() {
    return this.status.unitOnly;
  }
  
  /**
  *   issetaddress
  *
  */
  Checkout.prototype.issetAddress = function() {
    return ! _.isEmpty(this.address);
  }
  
  /**
  *   canSelectContact
  *
  */
  Checkout.prototype.canSelectContact = function() {
    return this.areContactsLoaded() &&
    this.issetAddress();
  }
  
  /**
  *   issetContact
  *
  */
  Checkout.prototype.issetContact = function() {
    // @NOTE double check this condition, it was !_.isEmpty(this.contact.contactId)
    // but it wasn't triggering ever
    return !_.isEmpty(this.contact) &&
      angular.isDefined(this.contact.contactId) &&
      this.Cart.fullyInit;
  }
  
  /**
  *   canSelectFreight
  *
  */
  // Checkout.prototype.canSelectFreight = function() {
  Checkout.prototype.canSelectFreight = function() {
    return this.issetContact() &&
    this.issetAddress() &&
    // @TODO check for freight quote ready
    this.Cart.items_count > 0 &&
    (! _.isEmpty(this.Shipping.freightOptions) || this.Shipping.loading);
  }
  
  /**
  *   isFreightQuoteready
  *   @TODO unify freight quote ready behavior here
  */
  Checkout.prototype.isFreighQuoteReady = function isCartFreightQuoteReady() {
  }
  
  /**
  *   issetFreight
  *
  */
  // Checkout.prototype.issetFreight = function() {
  Checkout.prototype.issetFreight = function() {
    return !_.isEmpty(this.freight);
  }
  
  /**
  *   canSelectShipping
  *
  */
  Checkout.prototype.canSelectShipping = function() {
    return this.canSelectFreight() &&
    // if it's unitOnly we have no shippingOptions
    ( ! _.isEmpty(this.Shipping.shippingOptions) || this.isUnitOnly()) &&
    this.issetFreight();
  }
  
  /**
  *   issetShipping
  *
  */
  Checkout.prototype.issetShipping = function() {
    return !_.isEmpty(this.shipping);
  }
  
  /**
  *   canSelectPaymentMethod
  *
  */
  Checkout.prototype.canSelectPaymentMethod = function() {
    return this.issetShipping() && this.status.paymentAvailable === true
  }
  
  /**
  *
  */
  Checkout.prototype.canCompleteOrder = function() {
    return this.canSelectPaymentMethod() && (
      (
        this.payment.payment_terms == 'Prepay' &&
        this.payment.card_type != null &&
        this.payment.card_number != null &&
        this.payment.exp_month != null &&
        this.payment.exp_year != null
      )
      ||
      (
        this.payment.payment_terms == 'NetTerms'
      )
    )
  }
  
  ////////////////////////// SHIPPING ADDRESS / CONTACT
  
  /**
  *   setContactId
  *
  */
  Checkout.prototype.setContactId = function(contact_id) {
    if (! contact_id) { return; }
    if (! this.Cart.fullyInit) { return; }
    
    this.shipping = {};
    // this.freight = {};
    this.freight = undefined
    
    this.contact.contactId = contact_id;
    
    // if cart is locked (freight quote ready) we wanna fetch freight options
    if (this.Cart.status.locked) {
      return this.getFreightOptions()
      .then(function () {
        // we are sure only 1 freight option returns here
        this.freight = this.Shipping.freightOptions[0];
        this.getShippingOptions();
      }.bind(this));
    }
    
    // if viewing the cart we now have what we need
    // also make sure we don't continue if we have no items in the cart
    if (this.Cart.mode === 'view' || this.Cart.items_count === 0) {
      return;
    }
    
    return this.updateShipping()
      .then(function() {
        return this.getFreightOptions();
      }.bind(this));
  }
  
  //////////////////////////// FREIGHT / SHIPPING METHOD
  
  /**
  *   updateShipping
  *
  *   called when contact.contactId or shipping{} are being updated
  *   we always pass all parameters, defaulting to null where applicable
  */
  Checkout.prototype.updateShipping = function() {
    
    var cart_id = this.Cart.status.locked && this.Cart.cart_id ? this.Cart.cart_id : null;
    
    var payload = {
      // cart_id: cart_id,
      ship_to_id: this.address.site_use_id,
      contact_id: this.contact.contactId,
      freight_terms_code: this.freight ? this.freight.freight_terms_code : null,
      shipment_priority_code: this.shipping.shipment_priority_code || null,
      shipping_method_code: this.shipping.shipping_method_code || null,
      customer_po_number: this.instructions.customer_po_number || ' ',
      shipping_instructions: this.instructions.shipping_instructions || ' ',
      packing_instructions: this.instructions.packing_instructions || ' '
    }

    return this.Shipping.updateShipping(payload, cart_id)
  }
  
  ///////////////////////// FREIGHT
  
  /**
  *   getFreightOptions
  *
  */
  Checkout.prototype.getFreightOptions = function() {
    if (! this.issetContact()) throw "Can't get Freight Options";
    
    var payload = {
      ship_to_id: this.address.site_use_id,
      contact_id: this.contact.contactId
    };
    
    // on freight quote ready we pass the cart id
    var cart_id = this.Cart.status.locked && this.Cart.cart_id ? this.Cart.cart_id : null;
    
    return this.Shipping.getFreightOptions(payload, cart_id)
    // check if we fall into the unit_only order, which depends on what
    // freight options we receive. if we are we default freight/shipping to
    // 'Best Way'
    .then(function(response) {
      // response is a bool
      if (! this.Shipping.freightOptions) return;
      if (this.Shipping.freightOptions.length > 1) return;
      
      if (this.Shipping.freightOptions[0].freight_terms_label === 'Freight Included On Unit Orders') {
        this.status.unitOnly = true;
        this.freight = this.Shipping.freightOptions[0];
        return this.setFreight()
        .then(function() {
          // wait for Shipping.getShippingOptions to return
          // this.shipping.shipping_method_code = 'Best Way';
          this.shipping = this.Shipping.shippingOptions[0];
          this.updateShipping()
          .then(function(response) {
            this.status.paymentAvailable = true;
          }.bind(this))
        }.bind(this))
      } else if (this.Shipping.freightOptions.length === 1) {
        this.freight = this.Shipping.freightOptions[0];
        return this.setFreight();
      }
    }.bind(this))
    
  }
  
  /**
  *   setFreight
  *
  */
  Checkout.prototype.setFreight = function() {
    if (! this.canSelectFreight()) throw "Can't set Freight";
    // if (this.Cart.status.locked) throw "Cannot set Freight when cart is locked";
    
    this.shipping = {};
    this.status.paymentAvailable = false;
    
    return this.getShippingOptions();
  }
  
  /**
  *   requestFreightQuote
  *
  */
  Checkout.prototype.requestFreightQuote = function() {
    if (! this.issetFreight() ) throw 'Can\'t get freight quotes';
    if (this.freight.quote_required !== 'Y') throw 'Cannot request quote';

    var defer = this.Cart.$q.defer();

    this.Shipping.requestFreightQuote()
      .then(response => {
        if (response.data.success) {
          this.Cart.resetOrders()
          this.status.quoteRequested = true
          this.status.quoteMessage = response.data.data
          this.Cart.items_count = 0
          defer.resolve(true)
        }
      }).catch(error => {
        defer.resolve(false)
      })
    
    return defer.promise;
  }
  
  
  ///////////////////////// SHIPPING
  
  /**
  *   getShippingOptions
  *
  */
  Checkout.prototype.getShippingOptions = function() {
    if (! this.issetFreight() ) throw "Can't select shipping";
    
    if (this.freight.quote_required === 'Y') {
      // make sure we clean previous selection, if one
      this.Shipping.shippingOptions = undefined;
      throw 'Freight quote required, no shipping options';
    }
    
    this.status.paymentAvailable = false;
    
    var payload = {
      freight_terms_code: this.freight.freight_terms_code || null,
      country_code: this.address.country
    }
    
    // on freight quote ready we pass the cart id
    var cart_id = this.Cart.status.locked && this.Cart.cart_id ? this.Cart.cart_id : null;

    return this.Shipping.getShippingOptions(payload, cart_id);
  }
  
  /**
  *   setShippingOption
  *
  */
  Checkout.prototype.setShippingOption = function() {
    if (!this.canSelectShipping()) throw Error(`Can't select shipping`);
    this.status.paymentAvailable = false;
    return this.updateShipping()
      .then(response => {
        // make sure the cart_id goes through if quote ready cart
        var cart_id = this.Cart.status.locked && this.Cart.cart_id ? this.Cart.cart_id : null;
        return this.Cart.refreshCart(true, cart_id)
          .then(response => {
            this.status.paymentAvailable = true;
          }, function (error) {
            throw Error('Problems updating shipping.');
          });
      })
      .catch(response => {
        this.Errors.set(response.error, 'shipping')
      })
  }
  
  Checkout.prototype.validateCard = function(nv, ov) {
    
    // if nothing changed return
    if (angular.equals(nv, ov)) {
      return;
    }
    
    // if we don't have enough info, return
    if (! this.payment.exp_month || ! this.payment.exp_year) {
      return;
    }
    
    var now = moment().endOf('month');
    
    var expiration = moment({
      day: 1,
      month: this.payment.exp_month,
      year: this.payment.exp_year
    })
    
    if (expiration.isBefore(now)) {
      this.Errors.set("Expiration date is invalid", "paymentDate")
    } else {
      this.Errors.reset("paymentDate")
    }
    
  }
  
  Checkout.prototype.charge = function() {
    
    var payload = {
      ship_to_id: this.address.site_use_id,
      contact_id: this.contact.contactId,
      payment_terms: this.payment.payment_terms,
      freight_terms_code: this.freight.freight_terms_code,
      shipping_method_code: this.shipping.shipping_method_code,
      customer_po_number: this.instructions.customer_po_number || null,
      shipping_instructions: this.instructions.shipping_instructions || null,
      packing_instructions: this.instructions.packing_instructions || null,
      shipment_priority_code: this.shipping.shipment_priority_code || null,
    }
    
    if (this.payment.payment_terms === 'Prepay') {
      payload.card_type = this.payment.card_type.name;
      payload.card_number = this.payment.card_number;
      payload.card_name = this.payment.card_name;
      payload.card_exp = this.payment.exp_month + "/" + this.payment.exp_year;
    }
    
    // on freight quote ready we pass the cart id
    if (this.Cart.status.locked && this.Cart.cart_id) payload.cart_id = this.Cart.cart_id;
    
    this.status.charging = true;

    this.Errors.reset("charging")

    return this.Cart.charge(payload)
      .then(response => {
        if (response.message) {
          this.Errors.set(response.message, "confirmation")
        }
        if (typeof response.cart_id !== 'undefined') {
          this.Cart.init()
          this.$location.path("/confirmation/" + response.cart_id)
          return Promise.resolve(response.data)
        } else {
          this.Cart.init()
        }
      })
      .catch(response => {
        if (response.data.warning && response.data.warning.length) {
          // in case of failure we can have multiple `warning`
          // collect message for modal
          let modals = []
          response.data.warning.forEach(warning => {
            if (warning.message.notification_type === 'error') {
              modals.push(warning.message.message)
            }
          })
          if (modals.length) {
            this._$rootScope.$emit('modal.open', {title: 'Error while charging your order', template: 'error', data: {message: modals}})
          }
        } else {
          this.Errors.set(response.data.error, "charging")
        }
        var cart_id = this.Cart.status.locked && this.Cart.cart_id ? this.Cart.cart_id : null;
        this.Cart.init(cart_id)
      })
    
  }
  
})()


// WEBPACK FOOTER //
// ./src/app/modules/Cart/services/Checkout.js